import html2canvas from "html2canvas";

export interface ScreenshotCaptureOptions {
  quality?: number; // 0..1
  scale?: number;
  hideSelectors?: string[];
}

export async function captureScreenshot(
  options: ScreenshotCaptureOptions = {},
): Promise<Blob | null> {
  const quality = typeof options.quality === "number" ? options.quality : 0.8;
  const scale = typeof options.scale === "number" ? options.scale : 1;

  const hidden: Array<{ el: HTMLElement; prevVisibility: string }>=[];

  try {
    if (options.hideSelectors?.length) {
      for (const selector of options.hideSelectors) {
        document.querySelectorAll(selector).forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          hidden.push({ el: node, prevVisibility: node.style.visibility });
          node.style.visibility = "hidden";
        });
      }
    }

    const canvas = await html2canvas(document.body, {
      useCORS: true,
      allowTaint: false,
      scale,
      backgroundColor: null,
      logging: false,
      // Try to avoid oversized renders on huge pages
      windowWidth: document.documentElement.clientWidth,
      windowHeight: document.documentElement.clientHeight,
      scrollX: 0,
      scrollY: 0,
    });

    const blob: Blob | null = await new Promise((resolve) => {
      canvas.toBlob(
        (b) => resolve(b),
        "image/jpeg",
        Math.min(Math.max(quality, 0.1), 0.95),
      );
    });

    return blob;
  } catch (err) {
    console.warn("[screenshotCapture] Failed to capture screenshot", err);
    return null;
  } finally {
    for (const { el, prevVisibility } of hidden) {
      el.style.visibility = prevVisibility;
    }
  }
}
